import ApiCore from './api-core'
import { PUBLIC } from '@/constants/api-types'

export default class File extends ApiCore {
  constructor(store) {
    const path = `${PUBLIC}/file`
    super(store, path)
  }

  upload(model, showProgress, onUploadProgress) {
    return this.request({
      action: 'temp/upload',
      method: 'POST',
      body: model,
      showProgress,
      onUploadProgress
    })
  }

  delete(fileName, showProgress) {
    return this.request({
      action: `temp/${fileName}`,
      method: 'DELETE',
      showProgress
    })
  }
}
